import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { advanceParamCheck } from '../../utils';

export interface StartBluetoothDevicesDiscoveryOption
  extends Partial<GeneralInvokeOption> {
  services?: Array<string>;
  invalidParamObj?: '';
}

// 开始搜寻附近的蓝牙外围设备
export function startBluetoothDevicesDiscovery(
  option: StartBluetoothDevicesDiscoveryOption
) {
  if (
    advanceParamCheck(
      APINames.Native.START_BLUETOOTH_DEVICES_DISCOVERY,
      option,
      { services: ['1'] },
      { services: { optional: true } })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.START_BLUETOOTH_DEVICES_DISCOVERY,
      option
    );
  }
  return option.invalidParamObj;
}
